/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* BUTTON SEARCH CUSTOM */
/* ******************** */
function goToResultsSearch() {
  const wordToSearch = document.querySelector('#Search .Search__Input').value;
  const parameters = `/search?q=${wordToSearch}`;
  window.location.href = window.location.origin + parameters;
}

document.querySelector('#Search .go-to-search-results').addEventListener('click', goToResultsSearch);
document.querySelector('#Search .Search__Input').addEventListener('keyup', (e) => {
  if (e.key === 'Enter' || e.keyCode === 13) {
    goToResultsSearch();
  }
});